<template>
  <step-container :number="stepNumber" title="¿En qué formato quieres las Memoorias?">
    <div class="flex flex-col justify-start items-center flex-grow basis-1/2">
      <card-option
        v-model="option"
        content="audio"
        index="0"
        name="format"
        :stepNumber="stepNumber"
      >
        <card-option-content
          title="Audio"
          description="Conversación tipo podcast, solo con grabación de audio"
          price="Incluido"
          :imageSrc="microphoneIllustration"
        />
      </card-option>
    </div>

    <div class="flex flex-col justify-start items-center basis-1/2 flex-grow">
      <card-option
        v-model="option"
        content="video"
        index="1"
        name="format"
        :stepNumber="stepNumber"
      >
        <card-option-content
          title="Audio & Video"
          description="Conversación tipo documental, una grabación con video incluido"
          price="+40.000 CLP"
          :imageSrc="cameraIllustration"
        >
        </card-option-content>
      </card-option>
    </div>
  </step-container>
</template>

<script setup>
import microphoneIllustration from "@assets/images/microphone.webp";
import cameraIllustration from "@assets/images/camera.webp";
</script>

<script>
import stepMixin from "../../mixins/step";
import optionMixin from "../../mixins/option";

import CardOption from "../options/CardOption.vue";
import CardOptionContent from "../options/CardOptionContent.vue";

export default {
  mixins: [stepMixin, optionMixin],
  components: {
    CardOption,
    CardOptionContent,
  },
};
</script>
